import * as types from './actionTypes';
import Resource from "../services/PrivateAPIResource";
import FormDataFormatter from '../services/FormDataFormatter';

export function createCourseSuccess(course) {
    return {type: types.CREATE_COURSE_SUCCESS, course};
}

export function updateCourseSuccess(course) {
    return {type: types.UPDATE_COURSE_SUCCESS, course};
}

export function cloneCourseSuccess(course) {
    return {type: types.CLONE_COURSE_SUCCESS, course};
}

export function loadCoursesSuccess(courses) {
    return {type: types.LOAD_COURSES_SUCCESS, courses};
}

export function getCourseSuccess(course) {
    return {type: types.GET_COURSE_SUCCESS, course};
}

export function deleteCourseSuccess(id) {
    return {type: types.DELETE_COURSE_SUCCESS, id};
}

export function clearCourseList() {
    return {type: types.CLEAR_COURSES_LIST}
}

export function resetCourse() {
    return { type: types.RESET_COURSE };
}

export function loadCourses(page, sortParams) {
    return function (dispatch) {
        return Resource.all(`courses?page=${page}`, sortParams).then(courses => {
            dispatch(loadCoursesSuccess(courses))
        }).catch(error => {
            throw  error;
        });
    }
}

export function getCourse(id) {
    return function (dispatch) {
        return Resource.get('courses', id).then(courses => {
            dispatch(getCourseSuccess(courses))
        }).catch(error => {
            throw  error;
        });
    }
}

export function updateCourseVimeo(id, data) {
    return function (dispatch) {
        return Resource.update(`courses/${id}`, 'vimeo', data).then(course => {
            dispatch(updateCourseSuccess(course));
        }).catch(error => {
            throw error;
        })
    }
}

export function updateCourse(course) {
    return function (dispatch, getState) {
        return Resource.update('courses', course.id, FormDataFormatter.getFormData(course), true).then(course => {
            dispatch(updateCourseSuccess(course));
        }).catch(error => {
            throw error;
        })
    }
}

export function cloneCourse(id) {
    return function (dispatch) {
        return Resource.get('courses/clone', id).then(courses => {
            dispatch(cloneCourseSuccess(courses))
        }).catch(error => {
            throw  error;
        });
    }
}

export function saveCourse(course) {
    return function (dispatch, getState) {
        return Resource.create('courses', FormDataFormatter.getFormData(course), true).then(course => {
            dispatch(createCourseSuccess(course));
        }).catch(error => {
            throw error;
        })
    }
}

export function deleteCourse(id) {
    return function (dispatch) {
        return Resource.remove('courses', id).then(courses => {
            dispatch(deleteCourseSuccess(id))
        }).catch(error => {
            throw  error;
        });
    }
}



// WEBPACK FOOTER //
// ./web/src/actions/courseActions.js